function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { useMemo, useState } from 'react';
import { InjectableServices } from '../enums';
import { AppService, AuthService, AvatarService, CandidateCartService, CandidateOnePagerService, ChatService, ClientService, ContractorProfileService, FboAuthService, FileActionsService, HideNavbarService, InterviewCopilotService, JobAiService, JobService, MfaService, OnboardingService, PerformanceTrackingService, RestTrackingService, ThemeService, UserService, UtilsService } from '../services';
export var useAppService = function() {
    var _useState = _sliced_to_array(useState(function() {
        return AppService.getOrCreate();
    }), 1), state = _useState[0];
    return state;
};
export var useAuthService = function() {
    var _useState = _sliced_to_array(useState(function() {
        return AuthService.getOrCreate();
    }), 1), state = _useState[0];
    return state;
};
export var useFboAuthService = function() {
    return useMemo(function() {
        return FboAuthService.getOrCreate();
    }, []);
};
export var useAvatarService = function() {
    return useMemo(function() {
        return AvatarService.getOrCreate();
    }, []);
};
export var useAvatarCollaboratorService = function() {
    return useMemo(function() {
        return AvatarService.getOrCreate(InjectableServices.AvatarCollaboratorService);
    }, []);
};
export var useAvatarSuggestedCollaboratorService = function() {
    return useMemo(function() {
        return AvatarService.getOrCreate(InjectableServices.AvatarSuggestedCollaboratorService);
    }, []);
};
export var useAvatarTalentPoolCandidateService = function() {
    return useMemo(function() {
        return AvatarService.getOrCreate(InjectableServices.AvatarTalentPoolCandidateService);
    }, []);
};
export var useAvatarEmployerCandidatesService = function() {
    return useMemo(function() {
        return AvatarService.getOrCreate(InjectableServices.AvatarEmployerCandidatesService);
    }, []);
};
export var useAvatarCandidatesListService = function() {
    return useMemo(function() {
        return AvatarService.getOrCreate(InjectableServices.AvatarCandidatesListService);
    }, []);
};
export var useAvatarTimelineService = function() {
    return useMemo(function() {
        return AvatarService.getOrCreate(InjectableServices.AvatarTimelineService);
    }, []);
};
export var useAvatarResumeService = function() {
    return useMemo(function() {
        return AvatarService.getOrCreate(InjectableServices.AvatarResumeService);
    }, []);
};
export var useSubmissionAvatarService = function() {
    return useMemo(function() {
        return AvatarService.getOrCreate(InjectableServices.SubmissionAvatarService);
    }, []);
};
export var useCandidateOnePagerService = function() {
    return useMemo(function() {
        return CandidateOnePagerService.getOrCreate();
    }, []);
};
export var useCandidateCartService = function() {
    return useMemo(function() {
        return CandidateCartService.getOrCreate();
    }, []);
};
export var useClientService = function() {
    var _useState = _sliced_to_array(useState(function() {
        return ClientService.getOrCreate();
    }), 1), state = _useState[0];
    return state;
};
export var useClientJobService = function() {
    return useMemo(function() {
        return JobService.getOrCreate();
    }, []);
};
export var useChatService = function() {
    return useMemo(function() {
        return ChatService.getOrCreate();
    }, []);
};
export var useContractorProfileService = function() {
    return useMemo(function() {
        return ContractorProfileService.getOrCreate();
    }, []);
};
export var useFileActionService = function() {
    return useMemo(function() {
        return FileActionsService.getOrCreate();
    }, []);
};
export var useHideNavbarService = function() {
    return useMemo(function() {
        return HideNavbarService.getOrCreate();
    }, []);
};
export var useInterviewCopilotService = function() {
    return useMemo(function() {
        return InterviewCopilotService.getOrCreate();
    }, []);
};
export var useJobAiService = function() {
    return useMemo(function() {
        return JobAiService.getOrCreate();
    }, []);
};
export var useMfaService = function() {
    return useMemo(function() {
        return MfaService.getOrCreate();
    }, []);
};
export var useOnboardingService = function() {
    return useMemo(function() {
        return OnboardingService.getOrCreate();
    }, []);
};
export var usePerformanceTrackingService = function() {
    return useMemo(function() {
        return PerformanceTrackingService.getOrCreate();
    }, []);
};
export var useRestTrackingService = function() {
    return useMemo(function() {
        return RestTrackingService.getOrCreate();
    }, []);
};
export var useThemeService = function() {
    var _useState = _sliced_to_array(useState(function() {
        return ThemeService.getOrCreate();
    }), 1), state = _useState[0];
    return state;
};
export var useUtilsService = function() {
    return useMemo(function() {
        return UtilsService.getOrCreate();
    }, []);
};
export var useUserService = function() {
    var _useState = _sliced_to_array(useState(function() {
        return UserService.getOrCreate();
    }), 1), state = _useState[0];
    return state;
};
